import gql from "graphql-tag";

export const SUBSCRIBE_SERVICE_PROVIDERS_COUNT = gql`
subscription serviceProvidersCount($search: String!){
  serviceProvidersCount: ServiceProviders_aggregate (where:{_and: [ {_or: [{companyName: {_ilike: $search}}, {city: {_ilike: $search}}, {ServiceCategory:{name:{_ilike: $search}}} ]}]}){
    aggregate{ count }
  }
}`

export const SUBSCRIBE_SERVICE_PROVIDERS = gql`
subscription serviceProviders($offset: Int!, $limit: Int!, $search: String!, $orderBy: [ServiceProviders_order_by!]){
  ServiceProviders (where:{_and: [ {_or: [{companyName: {_ilike: $search}}, {city: {_ilike: $search}}, {ServiceCategory:{name:{_ilike: $search}}} ]}]}, offset: $offset, limit: $limit, order_by: $orderBy){
    id
    ServiceCategory {id name}
    companyName
    personName
    image
    mobile
    whatsappNumber
    city
    state
    isChargeable
    experience
    isActive
    created_at
  }
}`